/**
 * Environment Variable Validator
 * Ensures all required environment variables are present
 */

interface EnvConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
}

export function validateEnvironment(): EnvConfig {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  const missing: string[] = [];

  if (!supabaseUrl) {
    missing.push('VITE_SUPABASE_URL');
  }

  if (!supabaseAnonKey) {
    missing.push('VITE_SUPABASE_ANON_KEY');
  }

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}\n` +
      'Please ensure all environment variables are set in your .env file or deployment configuration.'
    );
  }

  return {
    supabaseUrl,
    supabaseAnonKey,
  };
}

/**
 * Gets the OpenAI API key from user's BYOK (Bring Your Own Key)
 * 
 * Returns empty string if not available
 */
export function getOpenAIApiKey(): string {
  // BYOK only - user's personal key from localStorage
  const userKey = localStorage.getItem('openai_api_key');
  return userKey || '';
}

/**
 * Checks if OpenAI API key is available
 */
export function hasOpenAIApiKey(): boolean {
  return !!getOpenAIApiKey();
}

/**
 * Gets the source of the currently used API key
 * Returns 'byok' if using user's key, 'none' otherwise
 */
export function getApiKeySource(): 'byok' | 'none' {
  const userKey = localStorage.getItem('openai_api_key');
  
  if (userKey) return 'byok';
  return 'none';
}

